import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { CollectionPoint } from 'src/app/core/interfaces/collectionPoint';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Global } from 'src/app/core/resources/global';
import { environment } from 'src/environments/environment';
import { TermsAndConditions } from 'src/app/core/interfaces/termsAndConditions';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class LegalTermsService {
    public static driverHasValidTerms: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public static ownerHasValidTerms: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public static administratorHasValidTerms: BehaviorSubject<boolean> = new BehaviorSubject(false);

    collectionPointSelected: CollectionPoint;

    constructor(
        private http: HttpClient,
        private endpointResources: Endpoints
    ) {

    }

    public requestTermsAndPoliciesAcceptance(document: string, name: string, phone: string, holderCompanyNit: string, holderCompanyName: string, useAuxiliar: boolean = true) {
        let params = new HttpParams();
        if (document) params = params.append('userId', document);
        if (name) params = params.append('name', name);
        if (phone) params = params.append('phone', phone);
        if (holderCompanyNit && useAuxiliar) params = params.append('holderCompany', holderCompanyNit);
        if (holderCompanyName && useAuxiliar) params = params.append('company', holderCompanyName);
        if (!useAuxiliar) //Petición original de WhatsApp
            return this.http.put(`${environment.urlServerTeclogi}${this.endpointResources.requestTermsAndPoliciesAcceptance}`, {}, { params });
        //Petición auxiliar independiente de WhatsApp
        return this.http.get(`${environment.urlServerLoggiapp}${this.endpointResources.auxiliaryRequestTermsAndPoliciesAcceptance}`, { params });
    }

    public getDriverRegistrationUrl(holderCompanyId: string) {
        return `${environment.urlDriverRegistrationPortal}/masive-messages/drivers_registration/TyC/${holderCompanyId}`;
    }
    public getSMSMessage(name: string, holderCompanyName: string, holderCompanyId: string) {
        return `Hola ${name}, ${holderCompanyName} desea registrarte en LoggiApp para asignarte viajes. Para finalizar tu registro, acepta nuestras políticas aquí: ${this.getDriverRegistrationUrl(holderCompanyId)}`;
    }

    public getListTerms() {

        return this.http.get(
            environment.urlServerTeclogi + this.endpointResources.terms
        );
    }

    public getAll() {
        return this.http.get(
            environment.urlServerTeclogi + this.endpointResources.getAllPolicies
        );
    }

    public createTermsAndConditions(data: any) {

        return this.http.post(
            environment.urlServerTeclogi + this.endpointResources.terms,
            data
        );
    }

    public downloadTerms(url: string) {

        return this.http.get(url, { responseType: 'blob' });
    }

    public getTermsActive() {

        return this.http.get<TermsAndConditions[]>(
            environment.urlServerTeclogi + this.endpointResources.termsActive
        );
    }

}
